module.exports = __webpack_public_path__ + "static/applications-63ec93529793c8f7235e5a41fed04782.svg";